import { useParams, useSearchParams } from "react-router-dom";
// components
import { DetailsView } from '../../../automationObjects/components/DetailsView'
import { LoadingView } from "../../../components";
// services
import { useGetObjectByIdQuery, useGetRelationsOutByIdQuery } from '../../../services/objects'
import { NavigateablePage } from '../../../components/NavigateablePage';
import { Button, KIND, SHAPE } from "baseui/button";
import { useEffect, useState } from "react";
import { Drawer, SIZE } from "baseui/drawer";
import { DetailsPanel } from "../../../automationObjects/components/DetailsPanel";
import { useStyletron } from "baseui";
import { AccessRoles } from "../../../hooks/useHasRole/accessRoles";
import { useHasRole } from "../../../hooks/useHasRole";
import { PLACEMENT, StatefulPopover } from "baseui/popover";
import { StatefulMenu } from "baseui/menu";
import { MoveAppDialog } from "../../MoveApp";
import { Overflow } from "baseui/icon";
import { useIntl } from "react-intl";
import { IAutomationObject } from "../../../automationObjects";
import { schema as schemaBuilding } from '../../../automationObjects/Plants/Buildings/P_Building'
import { schema as schemaCampus } from '../../../automationObjects/Collections/SpaceCollections/Campus'
import { GetAddAppFilter, HasAddAppSupport, IsSmartApp } from "../../../automationObjects/automationObjectsSelector";
import { CreateObjectDialog } from "../../ObjectCreator/CreateObjectDialog";
import { ObjectCreator } from "../../ObjectCreator/ObjectCreator";
import { Modal, ModalBody, ModalHeader } from "baseui/modal";
import { ModalAutoSize } from "../../../components/ModalAutoSize";
import CloneAppDialog from "../../CloneAppDialog/CloneAppDialog";

export const ObjectDetailsView = () => {

    const hasAccessObject = useHasRole(AccessRoles.Object.Write);
    const hasAccessObjectDelete = useHasRole(AccessRoles.Object.Delete);
    const prms = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenMoveApp, setIsOpenMoveApp] = useState(false);
    const [isCloneOpen, setIsCloneOpen] = useState(false);
    const [objectId, setObjectId] = useState(prms.objectId);
    const [resourceGroupId, setResourceGroupId] = useState(prms.resourceGroupId);

    const [defaultView, setDefaultView] = useState(searchParams.get("defaultView"));

    // get object data
    const { data, isLoading, isFetching, isSuccess, error } = useGetObjectByIdQuery({ resourceGroupId: resourceGroupId || '', id: objectId || '' }, { skip: !objectId || !resourceGroupId, refetchOnReconnect: true })
    const { data: parents, isLoading: isLoadingParents } = useGetRelationsOutByIdQuery({ objectId: objectId || '', resourceGroupId: resourceGroupId || '', type: 'ContainedIn' });
    const parent = parents && parents.length > 0 ? parents[0] : undefined;

    useEffect(() => {
        setObjectId(prms.objectId)
    }, [prms.objectId])

    useEffect(() => {
        setResourceGroupId(prms.resourceGroupId)
    }, [prms.resourceGroupId])

    useEffect(() => {
        setDefaultView(searchParams.get("defaultView"))
    }, [searchParams])


    const handleFilter = (item: IAutomationObject) => {
        if (data.schema === schemaBuilding)
            return item.schema === schemaCampus;
        return item.resourceGroupId === data.resourceGroupId;
    }
    const isSmartApp = IsSmartApp({ tag: data?.schema });
    return (
        <>
            {objectId && resourceGroupId &&
                <>
                    <NavigateablePage
                        resourceGroupId={resourceGroupId}
                        objectId={objectId}
                        objectName={data?.name}
                        objectDescription={data?.description}
                        showNavigateBack
                        bottomActionButtons={<BottomActionButton app={data}></BottomActionButton>}
                        actionButton={
                            <>
                                {isSmartApp && <>🧠</>}
                                <ActionButton
                                    canShowDetails={hasAccessObject && data} onShowDetails={() => setIsOpen(true)}
                                    canMove={hasAccessObjectDelete && data} onMove={() => setIsOpenMoveApp(true)}
                                    canAddApp={hasAccessObjectDelete} onAddApp={() => alert("notImplemented")}
                                    canClone={hasAccessObjectDelete && data} onClone={() => setIsCloneOpen(true)}
                                ></ActionButton></>} >
                        <LoadingView isLoading={isLoading || isFetching} isSucess={isSuccess} error={error}>
                            <DetailsView  {...data} defaultView={defaultView}>
                            </DetailsView>
                        </LoadingView>
                    </NavigateablePage>
                    <Drawer
                        isOpen={isOpen}
                        autoFocus
                        size={SIZE.auto}
                        onClose={() => setIsOpen(false)}
                    >
                        {isOpen && <DetailsPanel  {...data}></DetailsPanel>}
                    </Drawer>
                    {isOpenMoveApp && <MoveAppDialog onFilter={handleFilter} currentParent={parent} isOpen={isOpenMoveApp} setIsOpen={(args) => setIsOpenMoveApp(args)} appToMove={data}></MoveAppDialog>}
                    {isCloneOpen && <CloneAppDialog appToClone={data} isOpen={isCloneOpen} setIsOpen={(args) => setIsCloneOpen(args)}></CloneAppDialog>}
                </>
            }
        </>
    )
}

const ActionButton = ({ canShowDetails, onShowDetails, canMove, onMove, canAddApp, onAddApp, onClone, canClone }) => {
    const [css, theme] = useStyletron();
    const intl = useIntl();


    const items = [
        //{ label: "New App", action: onAddApp, disabled: !canAddApp },
        { label: intl.formatMessage({ id: "MoveAppDialog.Title", defaultMessage: "Move to" }), action: onMove, disabled: !canMove },
        { label: intl.formatMessage({ id: "CloneAppDialog.Title", defaultMessage: "Clone App" }), action: onClone, disabled: !canClone },
        { divider: true },
        { label: intl.formatMessage({ id: "details", defaultMessage: "Details" }), action: onShowDetails, disabled: !canShowDetails },
    ]
    return (<StatefulPopover
        focusLock
        placement={PLACEMENT.bottomLeft}
        content={({ close }) => (
            <StatefulMenu
                items={items}
                onItemSelect={(args) => onSelect(args, close)}
            />
        )}
    >
        <Button title="more" kind={KIND.tertiary} shape={SHAPE.circle} >
            <Overflow title={'more'} color={theme.colors.primary500}></Overflow>
        </Button>
    </StatefulPopover>);

    function onSelect(args, close) {
        close();
        args.item.action();

    }
}

const BottomActionButton = (props: { app: IAutomationObject }) => {

    const hasCreateRights = useHasRole(AccessRoles.Object.Delete);
    const [showDialog, setShowDialog] = useState(false);

    if (!props.app)
        return (<></>)

    const hasSupportForThis = HasAddAppSupport(props.app.schema);
    if (!hasCreateRights || !hasSupportForThis)
        return (<></>)


    const myfilter = GetAddAppFilter(props.app.schema);
    return (
        <>
            <Button shape="circle" onClick={() => setShowDialog(true)}>+</Button>
            {showDialog && myfilter !== undefined &&
                <ModalAutoSize
                    isOpen={showDialog}
                    setIsOpen={() => setShowDialog(false)}
                    header={'Create new App'}
                    footer={<></>}
                    body={<ObjectCreator hideTemplates object={props.app} filter={myfilter}></ObjectCreator>
                    }></ModalAutoSize>
            }
        </>
    )
}